module.exports = __webpack_public_path__ + "assets/3013798e7ff88abbce563186ab7d7463.png";